import { ConfigValueType } from '../enums/ConfigValueType.enum';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function getDefaultValueByConfigType(type: ConfigValueType) {
  switch (type) {
    case ConfigValueType.Boolean:
      return true;
    case ConfigValueType.Integer:
    case ConfigValueType.Number:
      return 0;
    case ConfigValueType.String:
      return '';
  }
}
